import styled from 'styled-components'
import { Row, Col, Container } from 'react-bootstrap'
import Buton from '../shared/Button'
import Text from '../shared/Text'
import styles from '../../utility/styles'
import { Stars } from '../shared/Stars'
import {
	CommentsNum,
	ChargerInCharge,
	Mayor,
	WiFiIcon,
	CafeIcon,
	RestaurantIcon,
	LodgingIcon,
	ShoppingIcon,
	RestroomsIcon,
	Directions,
} from '../../utility/icons'

const ids = {
	restrooms: 'AMENITIES_RESTROOMS',
	restaurant: 'AMENITIES_RESTAURANT',
	wifi: 'AMENITIES_WIFI',
	cafe: 'AMENITIES_CAFE',
	lodging: 'AMENITIES_LODGING',
	shopping: 'AMENITIES_SHOPPING',
}

const AnenityIcon = ({ amenity }) => {
	switch (amenity) {
		case ids.restaurant:
			return <RestaurantIcon style={{ scale: `${16 / 24}` }} />
		case ids.wifi:
			return <WiFiIcon style={{ scale: `${16 / 24}` }} />
		case ids.cafe:
			return <CafeIcon style={{ scale: `${16 / 24}` }} />
		case ids.lodging:
			return <LodgingIcon style={{ scale: `${16 / 24}` }} />
		case ids.shopping:
			return <ShoppingIcon style={{ scale: `${16 / 24}` }} />
		case ids.restrooms:
			return <RestroomsIcon style={{ scale: `${16 / 24}` }} />
		default:
			return false
	}
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
`

const MyRow = styled.div`
	display: flex;
	align-items: center;
	align-self: ${({ align }) => align};
`

const StyledRow = styled.div`
	display: flex;
	flex: 1;
	margin-bottom: 12px;
	width: 100%;
	flex-wrap: wrap;
`

const StyledCol = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 8px;
	align-items: center;
	width: 50%;
	@media only screen and ${styles.breakpoints.desktop} {
		// all one row	
		width: 25%
	}
	@media only screen and ${styles.breakpoints.mobile} {
		width: 50%;
	}
`

const AmenitiesContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin: auto;
	@media only screen and ${styles.breakpoints.desktop} {
		flex: 1;
		justify-content: flex-start;
	}
	@media only screen and ${styles.breakpoints.mobile} {
		flex: initial;
		justify-content: center;
	}
`

const AmenityCol = styled.div`
	display: flex;
`

const AmenityRow = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	margin: 0 4px 8px 4px;
`

const DirectionsCol = styled.div`
	display: flex;
	flex: 1;
	justify-content: flex-end;
	@media only screen and ${styles.breakpoints.desktop} {
		flex: 0;
	}
	@media only screen and (max-width: 450px) {
		flex: 1;
		justify-content: center;
		align-items: center;
	}

`

const returnFriendlyName = id => {
	switch (id) {
		case ids.restaurant:
			return 'Restaurant'
		case ids.wifi:
			return 'WiFi'
		case ids.cafe:
			return 'Cafe'
		case ids.lodging:
			return 'Lodging'
		case ids.shopping:
			return 'Shopping'
		case ids.restrooms:
			return 'Restrooms'
		default:
			return ''
	}
}

/**
 *
 * @param {{
 *   amenities: string[],
 *   ratings:number,
 *   commentsNum:number,
 *   mayor:string,
 *   chargerInCharger:string,
 *   location:[longitude:number,latitude:number],
 *   style:import('react').CSSProperties
 * }} param0
 * @returns
 */
export default function ChargerInfo({
	amenities = [],
	ratings,
	commentsNum,
	mayor,
	chargerInCharger,
	location,
	style,
}) {
	return (
		<Wrapper {...{ style }}>
			<StyledRow>
				<StyledCol>
					<Stars {...{ ratings }} />
				</StyledCol>
				<StyledCol>
					<MyRow>
						<CommentsNum />
						<Text.Caption variant='bold'>
							{commentsNum}
						</Text.Caption>
					</MyRow>
				</StyledCol>
				<StyledCol>
					<MyRow>
						<ChargerInCharge />
						<Text.Caption variant='bold'>
							{chargerInCharger}
						</Text.Caption>
					</MyRow>
				</StyledCol>
				<StyledCol>
					<MyRow>
						<Mayor />
						<Text.Caption variant='bold'>{mayor}</Text.Caption>
					</MyRow>
				</StyledCol>
			</StyledRow>
			<StyledRow>
				<AmenitiesContainer>
					{amenities.map(({ id, friendy_name }) => {
						const name = returnFriendlyName(id)
						return (
							<AmenityCol key={id}>
								<AmenityRow>
									<AnenityIcon amenity={id} />
									<Text.Caption
										color={styles.colors.lightGray}
										variant='bold'
									>
										{friendy_name ?? name}
									</Text.Caption>
								</AmenityRow>
							</AmenityCol>
						)
					})}
				</AmenitiesContainer>
				<DirectionsCol>
					<Buton
						as='a'
						variant='secondary'
						href={`https://www.google.com/maps/dir/?api=1&destination=${location[0]},${location[1]}&travelmode=driving`}
						style={{ textDecoration: 'none' }}
						target='_blank'
					>
						<Directions style={{ marginRight: '6px' }} />
						Directions
					</Buton>
				</DirectionsCol>
			</StyledRow>
		</Wrapper>
	)
}
